import { fork, put, takeLatest } from 'redux-saga/effects';

import * as secondCBILSDashboardActions from './SecondCBILSDashboard.actions';
import { putAndWaitHandleAllAPIError } from '../../../api/API.sagas';
import * as lendingApiActions from '../../../api/lendingAPI/LendingAPI.actions';

export const SecondCBILSDashboardSagasWorkers = [
    fork(secondCBILSDashboardPageWorkers)
];

function* secondCBILSDashboardPageWorkers() {
    yield takeLatest(
        secondCBILSDashboardActions.ACTIVATE_SECOND_CBILS_DASHBOARD,
        function* () {
            yield putAndWaitHandleAllAPIError([
                {
                    type: lendingApiActions.API_GET_CUSTOMER_STATE
                },
                {
                    type: lendingApiActions.API_GET_APPLICATION
                },
                { type: lendingApiActions.API_GET_ACCOUNTS }
            ]);

            yield put({
                type: secondCBILSDashboardActions.SECOND_CBILS_DASHBOARD_READY
            });
        }
    );
}
